/* ResourceList — the page frame around `ResourceTable`.
 *
 * spec/03 archetype A's head, and nothing else: the shell owns the navigation, `ResourceTable`
 * owns the filter card, the table card and the bulk bar. The head is title + one-line subtitle +
 * the primary action, as `/visit`, `/supervisors` and `/points` all draw it — the New button used
 * to sit in the table's toolbar, which put the page's one primary action somewhere no other list
 * keeps it.
 */
import React from "react";
import { Button, Flex, Typography } from "antd";
import { PlusOutlined } from "@ant-design/icons";

import ResourceTable from "./ResourceTable";
import { POINTS_ADMIN } from "../../config/lang";
import { translate } from "../../util/util";

export default function ResourceList({ descriptor, currentUser, history }) {
  const lang = currentUser.language;
  const t = key => translate(POINTS_ADMIN, key, lang);

  const open = id =>
    history.push(
      id === "new" ? descriptor.newPath || `/${descriptor.slug}/new` : descriptor.detailPath ? descriptor.detailPath(id) : `/${descriptor.slug}/${id}`
    );

  return (
    <Flex vertical gap="middle" className="shell-content lp">
      <Flex className="lp-head" justify="space-between" align="flex-end" gap="middle" wrap>
        <Flex vertical>
          <Typography.Title level={1} className="lp-title">
            {t(descriptor.titleKey)}
          </Typography.Title>
          {/* Optional: a descriptor says what its records are FOR, which is the one thing a
              reference list's title cannot. */}
          {descriptor.subtitleKey && (
            <Typography.Paragraph type="secondary" className="lp-sub">
              {t(descriptor.subtitleKey)}
            </Typography.Paragraph>
          )}
        </Flex>
        <Button type="primary" icon={<PlusOutlined />} onClick={() => open("new")}>
          {t("new_btn")}
        </Button>
      </Flex>

      <ResourceTable descriptor={descriptor} currentUser={currentUser} onOpen={open} />
    </Flex>
  );
}
